/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Delete_TitleInputs */

const en_settings_apikeys_delete_title = /** @type {(inputs: Settings_Apikeys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete API key?`)
};

/**
* | output |
* | --- |
* | "Delete API key?" |
*
* @param {Settings_Apikeys_Delete_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_delete_title = /** @type {((inputs?: Settings_Apikeys_Delete_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Delete_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_delete_title(inputs)
});
export { settings_apikeys_delete_title as "settings.apikeys.delete_title" }